import React, { useState, useEffect} from 'react'
import Room from '@material-ui/icons/Room'
import Home from '@material-ui/icons/Home'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import { useRest } from '../contexts/rest/use'
import { useTranslation } from '../contexts/i18n/use'

export const Footer = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { state: {offices, selectedoffice }} = useRest();
  const { actions: {t}} = useTranslation();
  const [office, setOffice] = useState();

  useEffect(() => {
    if (offices && selectedoffice)
      setOffice(offices.find(x => x.officeID === selectedoffice))
  }, [offices, selectedoffice])

  return (
    <section className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.contentwrapper}>
          <Room className={[classes.icon, "icons", "footer-icons"].join(' ')}/>
          <div className={classes.content}>
            <Typography variant="body2" className={[classes.contenttext, "footer-text"].join(' ')}>
              { office ? office.address.street : t('footer.loading') }
            </Typography>
            <Typography variant="body2" className={[classes.contenttext, "footer-text"].join(' ')}>
              { office ? office.address.zipcode + " " + office.address.city : t('footer.loading')}
            </Typography>
          </div>
        </div>
        <div className={classes.contentwrapper}>
          <Home className={[classes.icon, "icons", "footer-icons"].join(' ')}/>
          <div className={classes.content}>
            <Typography variant="body2" className={[classes.contenttext, "footer-text"].join(' ')} onClick={(e) => { e.preventDefault(); window.open(t('footer.customerurl'))}}>
              { t('footer.customerurl').replace(/^https?:\/\//, '') || "" }
            </Typography>
          </div>
        </div>
      </div>
    </section>
  )
}

const useStyles = makeStyles({
  container: {
    display: 'flex', 
    flexShrink: 0,
    flexDirection: 'row', 
    width: '100%'
  },
  map: {
    backgroundColor: 'pink',
    display: 'flex',
    flex: '0 1 auto'
  },
  wrapper: theme => ({
    display: 'flex', 
    flexDirection: 'column',
    paddingTop: '0.25rem',
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.primary.main,
  }),
  contentwrapper: {
    display: 'flex', 
    flex: '1 0 auto',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'start',
    padding: '2px',
    height: '2rem'
  },
  content: theme => ({
    width: '100%',
    display: 'flex', 
    flexDirection: 'column',
    color: theme.palette.footer_color.main
  }),
  icon: theme => ({
    color: theme.palette.footer_color.main,
    width: 'auto',
    height: '65%'
  }),
  contenttext: {
    padding: 0, 
    margin: 0, 
    paddingLeft: '1rem'
  }
})
